/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 maskmowebsite.glb 
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export function Itchi(props) {
  const { nodes, materials } = useGLTF('/media/models/maskmowebsite.glb')
  return (
    <group {...props} dispose={null}>
      <mesh geometry={nodes.Mask_SongofSorrow001.geometry} material={materials['Porcelain Cracks']} />
    </group>
  )
}

useGLTF.preload('/media/models/maskmowebsite.glb')
